export default {
	'hide-zero-lines': 'sıfır çizgilerini gizle'
}